export enum StartOfDay {
  FIRST_SHIFT_START = 'FIRST_SHIFT_START',
  LAST_SHIFT_END = 'LAST_SHIFT_END'
}
